import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer";
import LowerFooter from "../components/LowerFooter";
import { Outlet } from "react-router-dom";
import { Box, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import TopNavbar from "../components/Navbar/TopNavbar";

const Layout = () => {
  const theme = createTheme({
    palette: {
      mode: "light",
      primary: {
        light: "",
        main: "#C4AB92",
        dark: "",
      },
    },
    typography: {
      allVariants: {
        color: "#4D5959",
      },
    },
  });
  const darkmode = createTheme({
    palette: {
      mode: "dark",
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <TopNavbar />
        <Navbar />
        <Box>
          <Outlet />
        </Box>
        <Footer />
        <LowerFooter />
      </CssBaseline>
    </ThemeProvider>
  );
};

export default Layout;
